import { defineComponent as r, openBlock as l, createElementBlock as s, withKeys as a, renderSlot as c } from "vue";
import { _ as p } from "../../../_plugin-vue_export-helper-dad06003.js";
const u = r({
  name: "VFloatingActionButton",
  emits: ["click"],
  setup: (t, o) => ({
    onClick: (e) => {
      o.emit("click", e);
    }
  })
});
function d(t, o, i, e, w, f) {
  return l(), s("button", {
    class: "hobi-floating-action-button tw-text-white tw-bg-orange tw-shadow-none tw-fixed tw-right-4 tw-bottom-4 tw-rounded-full tw-p-0 tw-font-normal tw-font-obi tw-whitespace-nowrap tw-no-underline tw-border-none",
    type: "button",
    onClick: o[0] || (o[0] = (...n) => t.onClick && t.onClick(...n)),
    onKeypress: o[1] || (o[1] = a((...n) => t.onClick && t.onClick(...n), ["enter"]))
  }, [
    c(t.$slots, "default", {}, void 0, !0)
  ], 32);
}
const _ = /* @__PURE__ */ p(u, [["render", d], ["__scopeId", "data-v-24b3556b"]]);
export {
  _ as default
};
